module.exports = __webpack_public_path__ + "images/signup-dingtalk-e3ff93214f8b207b9d40134c08192d34.png";